import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const HeatingPage = lazy(() => import('../pages/services/heating/page'));
const CoolingPage = lazy(() => import('../pages/services/cooling/page'));
const CommercialRefrigerationPage = lazy(() => import('../pages/services/commercial-refrigeration/page'));
const BoilersPage = lazy(() => import('../pages/services/boilers/page'));
const CommercialKitchenPage = lazy(() => import('../pages/services/commercial-kitchen/page'));
const EmergencyServicePage = lazy(() => import('../pages/emergency-service/page'));
const ServiceAreasPage = lazy(() => import('../pages/service-areas/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ReviewsPage = lazy(() => import('../pages/reviews/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/services/heating',
    element: <HeatingPage />,
  },
  {
    path: '/services/cooling',
    element: <CoolingPage />,
  },
  {
    path: '/services/commercial-refrigeration',
    element: <CommercialRefrigerationPage />,
  },
  {
    path: '/services/boilers',
    element: <BoilersPage />,
  },
  {
    path: '/services/commercial-kitchen',
    element: <CommercialKitchenPage />,
  },
  {
    path: '/emergency-service',
    element: <EmergencyServicePage />,
  },
  {
    path: '/service-areas',
    element: <ServiceAreasPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/reviews',
    element: <ReviewsPage />,
  },
  {
    path: '/faq',
    element: <FAQPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
